import { Props } from "../../../types";
import { classNameParser } from "../../../helpers";
import "./style.css";

type ValidationMessageProps = Props<{
  status?: "error" | "info" | "warning" | "success";
}>;

export const ValidationMessage = (props: ValidationMessageProps) => (
  <div className={classNameParser(`valid-message ${props.status || ""}`, props.className)}>
    <span className="global--caption">{props.children}</span>
  </div>
);
